import { gql } from '@apollo/client';
export const QuantityUnitQry = gql`
  {
    quantityUnits {
      id
      value
      shorthand
      code
    }
  }
`;
export const PrecarriageQry = gql`
{
  preCarriageAreas{
    id
    value
  }
}
`;
